import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { DateAdapter } from "./DateAdapter";

export class EntryDateAdapter extends DateAdapter {
  // need to override the moment.utc() of DateAdaptor
  retrieveData(order: any, columnProperty: string): string {
    let moment: CubiqTS.Moment = this.getDate(order, columnProperty);
    // TODO i18n
    if (moment) {
      return moment.format(this.localeString);
    }
    return "-";
  }
}
